<template>
    <div class="order-list">
        <div :class="{'bg-head-nav': true, 'bg-head-h187': isBgHeaderH187}"></div>
        <div class="area-1290 order-list-main">
            <div class="controller-container">
                <div class="controller-content">
                    <el-radio-group @change="getOrderListByCheckStatus" class="" v-model="checkStatusRadio">
                        <el-radio :label="0">未审核</el-radio>
                        <el-radio class="radio-last" :label="1">已审核</el-radio>
                    </el-radio-group>
                    <el-cascader v-if="userTypeNum == 0" class="action-select-inventory" placeholder="选择经销商" :filterable="true" :clearable="true" :options="oneLevelInventoryArr" v-model="oneLevelInventory" @change="selectOneLevelInventory">
                    </el-cascader>
<!--                    <el-cascader v-if="userTypeNum == 1 || userTypeNum == 0" class="action-select-inventory" placeholder="选择汽服门店仓库" :filterable="true" :clearable="true" :options="twoLevelInventoryArr" v-model="twoLevelInventory" @change="selectTwoLevelInventory">-->
<!--                    </el-cascader>-->
                    <el-button v-if="show && userTypeNum==0" class="action-select-inventory" @click="downloadErpTable">生成ERP表</el-button>
                    <el-button v-if="show" class="action-select-inventory" @click="downloadContracts">生成合同</el-button>
                </div>
            </div>
            <div class="table-container">
                <el-table @selection-change="selectAllOrder" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle" :data="tableData" tooltip-effect="dark" style="width: 100%">
                    <el-table-column
                            type="selection"
                            width="55">
                    </el-table-column>
<!--                    <el-table-column label="操作" align="center" min-width="15%">-->
<!--                        <template slot-scope="scope">-->
<!--                        <span v-if="userTypeNum == 0 && scope.row.order_type_num == 1">-->
<!--                            <el-button type="text" v-if="!scope.row.is_check" size="small" @click="findOrderDetail(scope.row.id, 'check')">进入审核</el-button>-->
<!--                            &lt;!&ndash; <el-button type="text" v-if="scope.row.is_check && scope.row.is_can_download" size="small" @click="downloadContract(scope.row.id)">下载合同</el-button> &ndash;&gt;-->
<!--                            <el-button type="text" v-if="scope.row.is_check" size="small" @click="findOrderDetail(scope.row.id, 'look')">查看详情</el-button>-->
<!--                        </span>-->
<!--                            <span v-if="userTypeNum == 0 && scope.row.order_type_num == 0">-->
<!--                            <el-button type="text" size="small" @click="findOrderDetail(scope.row.id, 'look')">查看详情</el-button>-->
<!--                        </span>-->
<!--                            <span v-if="userTypeNum == 1">-->
<!--                            <el-button type="text" v-if="!scope.row.is_check" size="small" @click="findOrderDetail(scope.row.id, 'check')">进入审核</el-button>-->
<!--                                &lt;!&ndash; <el-button type="text" v-if="scope.row.is_check && scope.row.is_can_download" size="small" @click="downloadContract(scope.row.id, 'look')">下载合同</el-button> &ndash;&gt;-->
<!--                            <el-button type="text" v-if="scope.row.is_check" size="small" @click="findOrderDetail(scope.row.id, 'look')">查看详情</el-button>-->
<!--                        </span>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column prop="agent" label="订货经销商" align="center" min-width="23%">
                    </el-table-column>
                    <el-table-column prop="user" label="订货人" align="center" min-width="23%">
                    </el-table-column>
                    <el-table-column prop="order_num" label="订单号" align="center" min-width="23%">
                    </el-table-column>
                    <el-table-column prop="erp_order_num" label="erp订单号" align="center" min-width="23%">
                    </el-table-column>
                    <el-table-column prop="status_name" label="审核状态" align="center" min-width="15%">
                    </el-table-column>
                    <el-table-column prop="create_time" label="日期" align="center" min-width="23%">
                    </el-table-column>
                    <el-table-column label="操作" align="center" min-width="15%" v-if="checkStatusRadio">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="fillERPOrderNum(scope.row.id)">填写订单号</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="提报状态" align="center" min-width="15%" v-if="checkStatusRadio && userTypeNum==0">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="isOffer(scope.row.id)">{{scope.row.is_offer}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
    } from 'vuex';
    import Tool from '../../assets/js/Tool.js';
    import Cookie from 'js-cookie';
    import axios from "axios";
    export default {
        data() {
            return {
                isHide: true,
                isBgHeaderH187: false,
                checkStatusRadio: 0,
                style: '',
                tableData: [],
                currentWarehouse_id: '',
                oneLevelInventoryArr: [],
                twoLevelInventoryArr: [],
                oneLevelInventory: [],
                twoLevelInventory: [],
                orderIdArr: [], // 获取每个item项
                show: false
            }
        },
        computed: {
            ...mapGetters(['user', 'userTypeNum'])
        },
        created() {
            this.init()
        },
        methods: {
            isOffer(order_id) {
                this.$confirm('是否修改提报状态?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post('https://xarh.sprucesmart.com/api/v3/order/offer/',{order_id}).then((res)=>{
                        if(res.data.errno==0){
                            this.$message({
                            type: 'success',
                            message: '修改成功!'});
                            this.getOrderListByCheckStatus()
                        }else{
                            this.$message({
                            type: 'fail',
                            message: '修改失败!'});
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消修改'
                    });          
                });
            },
                
            fillERPOrderNum(num){
                console.log("scope.row.id---",num)
                this.$prompt('请输入订单号', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    axios.post('https://xarh.sprucesmart.com/api/v3/order/fill_erp_order_num/',
                        {"user_id": this.user.id, "oid": num,"erp_order_num":value}).then((res)=>{
                        if(res.data.errno==0){
                            this.$message({
                                type: 'success',
                                message: "填写成功"
                            });
                        }else{
                            this.$message({
                                type: 'error',
                                message: res.data.results
                            });
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },

            // 下载合同
            downloadContracts() {
                if(this.orderIdArr.length == 0) {
                    this.$message({
                        type: 'warning',
                        message: '未选择要打印合同的订单！'
                    })
                    return;
                }
                window.open('https://xarh.sprucesmart.com/api/v1/print_contract?order_list=' + JSON.stringify(this.orderIdArr) + '&spl_token=' + Cookie.get('xian-spl-token') + '&oil_type=2','_blank');
            },
            changeTableHeaderStyle({row, rowIndex}) {
                return 'color:black; font-weight: bold;';
            },
            changeTableStyle ({row, column, rowIndex, columnIndex}) {
                if(columnIndex == 4) {
                    if(row.status_num == -1) {
                        return 'color: #FF3333;'
                    }
                    else if(row.status_num == 0) {
                        return 'color: #29bd7f;'
                    }
                    else if(row.status_num == 1) {
                        return 'color: #e6a23c;'
                    }
                }
                return 'color: #000;'
            },
            async init() {
                if(this.userTypeNum == 0) {
                    this.getInventoryStructure(this.user.id, 2, 'twoLevel');
                    this.getInventoryStructure(this.user.id, 1, 'oneLevel', async () => {
                    });
                }
                else if(this.userTypeNum == 1) {
                    this.getInventoryStructure(this.user.id, 1, 'twoLevel', async () => {
                    });
                    this.currentWarehouse_id = this.user.agent_id
                }
                // this.tableData =
                this.getNoChackOrderList()
            },
            downloadContract(oid) {
                window.open('https://xarh.sprucesmart.com/api/v1/print_contract?oid=' + oid + '&spl_token=' + Cookie.get('xian-spl-token'),'_blank');
            },
            // 选中的id
            selectAllOrder(val) {
                console.log('选中的item： ', val);
                if(val.length == 0) {
                    this.orderIdArr = [];
                }
                else {
                    this.orderIdArr = [];
                    val.forEach(item => {
                        this.orderIdArr.push(item.id)
                    });
                }
            },
            // 下载生成ERP表
            
            downloadErpTable() {
                window.location.href='https://xarh.sprucesmart.com/api/v1/erp_order_excel/?oid_list='+ JSON.stringify(this.orderIdArr)+'&order_type=2';
            },
            async getUnauditedOrderList(url) {
                let orderlist = await this.axios.get(url);
                return orderlist.data.data;
            },
            async getNoChackOrderList(){
                if(this.userTypeNum===1){
                    axios.get('https://xarh.sprucesmart.com/api/v3/order/admin_order_list/?status=1&agent='+this.currentWarehouse_id).then((res)=>{
                    this.tableData=res.data.results.data;
                    console.log("this.tableData--",this.tableData)
                    this.getNewOrderStatusList()
                })
                }else{
                    axios.get('https://xarh.sprucesmart.com/api/v3/order/admin_order_list/?status=1').then((res)=>{
                    this.tableData=res.data.results.data;
                    this.getNewOrderStatusList()
                })
                }
                
            },
            getInventoryStructure(user_id, type, level, callback) {
                this.axios.get('ns_branch_in', {
                    params: {
                        user_id: user_id,
                        type: type
                    }
                })
                    .then(res => {
                        if(level == 'twoLevel') {
                            this.twoLevelInventoryArr = res.data.data;
                        }
                        else {
                            this.oneLevelInventoryArr = res.data.data;
                        }
                        if((typeof callback) == 'function') {
                            callback();
                        }
                    })
            },
            getOrderListData(style, id, is_check) {
                this.axios.get('branch_orderlist', {
                    params: {
                        is_check: is_check,
                        id: id,
                        style: style
                    }
                })
                    .then(res => {
                        this.tableData = res.data.data;
                    })
            },
            // 点击审核与未审核的单选框
            getNewOrderStatusList(){
                this.tableData.forEach(item=>{
                    if(item.status===0){
                        item.status_name="待审核"
                    }else if(item.status===1){
                        item.status_name="待价格审核"
                    }else{
                        item.status_name="已审核"
                    }
                })
            },

            getOrderListByCheckStatus() {
                // 如果选中状态为审核就显示生成ERP表
                
                if (this.checkStatusRadio === 1) {
                    this.show = true
                } else {
                    this.show = false
                }
                let status = this.checkStatusRadio+1
                let agentParam = ""
                if(this.currentWarehouse_id){
                    agentParam="&agent="+this.currentWarehouse_id
                }
                axios.get('https://xarh.sprucesmart.com/api/v3/order/admin_order_list/?status='+status+agentParam).then((res)=> {
                    this.tableData=res.data.results.data;
                    this.getNewOrderStatusList()
                })
                
            },
            // 选择下级仓库结构
            selectOneLevelInventory() {
                this.currentWarehouse_id = this.oneLevelInventory[0];
                this.style = 1;
                let status= this.checkStatusRadio+1
                axios.get("https://xarh.sprucesmart.com/api/v3/order/admin_order_list/?agent="+this.currentWarehouse_id+"&status="+status).then((res)=> {
                    this.tableData=res.data.results.data;
                    this.getNewOrderStatusList()
                })
            },
            // 选择下2级仓库结构
            selectTwoLevelInventory() {
                if(this.twoLevelInventory.length == 1) {
                    this.currentWarehouse_id = this.twoLevelInventory[0];
                }
                else if(this.twoLevelInventory.length == 2) {
                    this.currentWarehouse_id = this.twoLevelInventory[1];
                }
                this.style = 2;
                this.getOrderListData(2, this.currentWarehouse_id, this.checkStatusRadio)

            },
            findOrderDetail(orderId, type) {
                if (type == 'look') {
                    let userStr = JSON.stringify(this.user);
                    console.log('userStr: ', userStr)
                    let routeData = this.$router.resolve({
                        'name': 'orderdetaillook',
                        'query': {
                            oid: orderId,
                            user: userStr
                        }
                    })
                    window.open(routeData.href, '_blank');
                } else {
                    let userStr = JSON.stringify(this.user);
                    console.log('userStr: ', userStr);
                    let routeData = this.$router.resolve({
                        'name': 'orderdetailcheck',
                        'query': {
                            oid: orderId,
                            user: userStr
                        }
                    })
                    window.open(routeData.href, '_blank');
                }
            }
        }
    }
</script>

<style scoped>
    @import url(../../assets/css/base.css);

    .order-list-main {
        position: relative;
        top: -63px;
        background-color: transparent;
    }

    .action-select-first,
    .action-select-inventory {
        margin-left: 24px;
        width: 133px;
    }

    .action-select-first {
        margin-left: 0px;
    }

    .bg-head-nav {
        background-color: #d2f5e8;
        height: 64px;
    }

    .bg-head-h187 {
        height: 187px;
    }

    .radio-last {
        /* margin-left: 15px; */
    }
</style>



// WEBPACK FOOTER //
// src/pages/orderManage/NewOrderList.vue